import { jsx as _jsx } from "preact/jsx-runtime";
export default function VideoSourceSelect({ currentDeviceId, videoSources, onChangeVideoSource, }) {
    return (_jsx("div", { className: "uppy-Webcam-videoSource", children: _jsx("select", { className: "uppy-u-reset uppy-Webcam-videoSource-select", onChange: (event) => {
                onChangeVideoSource(event.target.value);
            }, children: videoSources.map((videoSource) => (_jsx("option", { value: videoSource.deviceId, selected: videoSource.deviceId === currentDeviceId, children: videoSource.label }, videoSource.deviceId))) }) }));
}
